import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermManageJobsPostJobClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Post a Job" from the Manage Jobs page
 * Event: dental_portal:perm_manage_jobs:post_job_clicked
 */
export function firePermManageJobsPostJobClicked(
  payload: IPermManageJobsPostJobClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_manage_jobs:post_job_clicked', {
    posting_id: payload.postingId,
  });
}
